import { render, staticRenderFns } from "./RoyaltyDetails.vue?vue&type=template&id=06faa348&scoped=true"
import script from "./RoyaltyDetails.vue?vue&type=script&lang=js"
export * from "./RoyaltyDetails.vue?vue&type=script&lang=js"
import style0 from "./RoyaltyDetails.vue?vue&type=style&index=0&id=06faa348&prod&lang=less"
import style1 from "./RoyaltyDetails.vue?vue&type=style&index=1&id=06faa348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faa348",
  null
  
)

export default component.exports